import { User } from "@auth0/auth0-react";
import { GetUserResponse } from "../../proto/api_pb";
import { Dispatch, ReactNode, SetStateAction } from "react";
import { Track, TrackFile, User as ommuseUser } from "../../proto/api_pb";

export interface MenuItemType {
  value: ReactNode | string;
  id: number;
  route: string;
}

export interface Props {
  selectedWallet?: string;
  userVerified?: boolean;
  currentUser?: GetUserResponse;
}

export interface LoggedInAppBarProps {
  currentUser: GetUserResponse | undefined;
  userPages: {
    name: string;
    route: string;
  }[];
  handleOpenNavMenu: (event: React.MouseEvent<HTMLButtonElement>) => void;
  anchorElNav: (EventTarget & HTMLButtonElement) | null;
  handleCloseNavMenu: () => void;
  handleOpenUserMenu: (event: React.MouseEvent<HTMLButtonElement>) => void;
  anchorElUser: (EventTarget & HTMLButtonElement) | null;
  user: User | undefined;
  userMenu: MenuItemType[];
  handleCloseUserMenu: (item: MenuItemType) => void;
  setAnchorElUser: Dispatch<
    SetStateAction<(EventTarget & HTMLButtonElement) | null>
  >;
}

export interface GlobalSearchBarProps {
  userId: string;
  allowDisplaySearchBar: boolean;
  setAllowDisplaySearchBar: Dispatch<SetStateAction<boolean>>;
  isArtistSearchBar?: boolean;
}

export interface Option {
  title: string;
  group: string;
  image: string;
  moreDetails: Track | TrackFile | ommuseUser;
  id: string;
}

export const restrictedPathsForSearchBar = [
  "not-found",
  "privacy-policy",
  "creator-agreement",
  "enterprise-addendum",
  "terms-of-use",
  "initial-setting",
  "success",
  "payment-cancel",
  "signup",
  "login",
  "email-verification",
];

interface PageSteps {
  [key: string]: string;
}

export const pageSteps: PageSteps = {
  Tracks: "step-4",
  Files: "step-5",
  Explore: "step-6",
  Artists: "step-7",
};

export interface AccountMenuProps {
  handleOpenUserMenu: (event: any) => void;
  user: User | undefined;
  currentUser: GetUserResponse | undefined;
  anchorElUser: (EventTarget & HTMLButtonElement) | null;
  userMenu: MenuItemType[];
  setAnchorElUser: Dispatch<
    SetStateAction<(EventTarget & HTMLButtonElement) | null>
  >;
  handleCloseUserMenu: (item: MenuItemType) => void;
}
